var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 606,
    height: 606,
    viewBox: "0 0 606 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 303,
    r: 303,
    fill: "url(#paint0_radial_4_418)",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 303,
    r: 303,
    fill: "url(#paint1_linear_4_418)",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 302,
    r: 264,
    fill: "url(#paint2_radial_4_418)",
    fillOpacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 302,
    r: 264,
    fill: "url(#paint3_linear_4_418)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.147 457.827C493.924 468.589 484.251 475.53 476.608 481.013C386.773 545.471 280.474 526.682 257.883 522.093C224.522 515.318 160.037 502.22 113.415 447.394C42.8808 364.447 53.8641 233.766 108.576 147.501C118.583 131.722 171.446 44.1434 278.89 30.0987C343.914 21.599 419.71 38.742 474.6 84.7288C589.82 181.259 581.617 376.268 504.147 457.827Z",
    fill: "url(#paint4_linear_4_418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M563.983 217.902C563.964 214.972 560.021 214.014 558.671 216.613C545.611 241.745 509.304 306.573 468.028 336.383C400.822 384.919 344.11 474.671 368.627 532.401C368.627 532.401 566.088 537.088 563.983 217.902Z",
    fill: "#FF9085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M550.768 254.893C550.518 255.751 550.244 256.44 549.981 257.193L549.16 259.397L547.468 263.783C546.321 266.698 545.13 269.594 543.938 272.49C541.534 278.274 539.059 284.027 536.53 289.758C531.453 301.211 526.065 312.524 520.509 323.753C514.968 334.992 509.113 346.076 503.025 357.03C496.928 367.979 490.674 378.846 484.066 389.502C470.893 410.835 456.547 431.472 440.801 451.012C432.827 460.697 424.596 470.179 415.832 479.163C407.006 488.081 397.797 496.627 388.006 504.465C387.793 504.635 387.483 504.601 387.312 504.388C387.146 504.18 387.175 503.879 387.373 503.706L387.379 503.702C396.823 495.521 405.811 486.846 414.355 477.75C422.924 468.675 430.959 459.111 438.732 449.352C446.503 439.586 453.878 429.509 461.022 419.272C468.162 409.03 474.876 398.498 481.528 387.931C494.746 366.734 506.826 344.839 518.294 322.635C524.005 311.519 529.492 300.287 534.779 288.96C537.431 283.301 540.032 277.617 542.562 271.901L546.288 263.3L548.107 258.982L548.991 256.815C549.269 256.1 549.581 255.337 549.798 254.702L549.834 254.597C549.922 254.342 550.2 254.205 550.456 254.293C550.705 254.378 550.84 254.643 550.768 254.893Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M484.514 93.9105C483.697 91.2294 479.82 91.4258 479.291 94.1781C474.171 120.788 458.56 190.144 428.84 228.74C380.45 291.585 352.927 389.362 391.159 435.615C391.159 435.615 573.519 386.047 484.514 93.9105Z",
    fill: "#FEBBBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M482.495 131.438C482.5 132.295 482.437 133 482.402 133.763L482.25 136.009L481.897 140.492C481.641 143.479 481.339 146.46 481.037 149.441C480.411 155.401 479.712 161.353 478.958 167.298C477.428 179.186 475.575 191.031 473.544 202.846C471.531 214.664 469.185 226.426 466.592 238.133C463.988 249.838 461.217 261.51 458.064 273.085C451.804 296.243 444.276 319.082 435.165 341.297C430.492 352.354 425.529 363.295 419.94 373.924C414.277 384.509 408.161 394.859 401.317 404.715C401.165 404.933 400.865 404.987 400.647 404.836C400.434 404.688 400.378 404.399 400.515 404.183L400.519 404.177C406.944 394.096 412.818 383.688 418.169 373.015C423.55 362.355 428.307 351.392 432.772 340.322C437.232 329.247 441.246 317.994 445.004 306.658C448.757 295.318 452.039 283.828 455.258 272.323C461.598 249.28 466.702 225.906 471.165 202.416C473.371 190.666 475.34 178.868 477.101 167.04C477.99 161.127 478.826 155.205 479.588 149.273L480.661 140.369L481.152 135.913L481.373 133.685C481.433 132.955 481.51 132.169 481.537 131.529L481.542 131.421C481.553 131.158 481.775 130.953 482.038 130.964C482.293 130.975 482.493 131.185 482.495 131.438Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.398 119.628C160.679 188.963 155.104 428.122 157.765 512.874C158.047 521.852 165.245 529.059 174.223 529.352C218.63 530.806 346.375 534.489 419.009 531.442C434.138 530.807 446.168 518.553 446.482 503.414C447.992 430.639 451.321 225.95 443.406 132.182C442.458 120.947 433.64 112 422.421 110.878C374.06 106.04 245.615 94.2142 182.864 98.2864C171.547 99.0208 162.679 108.291 162.398 119.628Z",
    fill: "url(#paint5_linear_4_418)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.441 141.172C178.016 197.956 170.366 386.864 172.794 456.718C173.149 466.928 181.196 475.184 191.395 475.781C233.387 478.238 341.092 483.656 402.684 478.724C413.775 477.836 422.478 468.867 423.076 457.757C426.197 399.825 435.159 223.926 432.832 154.854C432.46 143.836 423.925 134.837 412.944 133.851C367.516 129.772 250.84 120.067 198.501 122.923C188.676 123.459 180.861 131.341 180.441 141.172Z",
    fill: "#FEBBBA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.144 110.401C272.144 112.529 273.802 114.284 275.926 114.395C286.415 114.944 315.961 116.498 329.166 117.264C331.769 117.415 333.813 115.075 333.319 112.514L333.235 112.077C332.898 110.33 331.448 109.015 329.676 108.852C320.751 108.035 293.818 105.767 275.973 106.404C273.83 106.48 272.144 108.257 272.144 110.401Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M389.628 345.926L211.092 342.499C205.272 342.387 200.889 349.167 201.37 357.564C201.845 365.877 207.916 368.383 213.621 368.295L388.277 369.693C391.855 369.639 395.045 364.382 395.439 357.907C395.835 351.381 393.25 345.996 389.628 345.926Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M390.111 400.688L211.576 397.26C205.755 397.149 201.372 403.928 201.853 412.326C202.329 420.639 208.399 423.144 214.104 423.057L388.761 424.455C392.339 424.4 395.529 419.144 395.922 412.668C396.319 406.142 393.734 400.757 390.111 400.688Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M313.458 353.416L216.568 352.409C213.409 352.376 211.034 354.195 211.298 356.451C211.561 358.683 214.856 359.36 217.952 359.339L312.737 359.799C314.678 359.786 316.407 358.375 316.617 356.637C316.829 354.884 315.424 353.436 313.458 353.416Z",
    fill: "url(#paint6_linear_4_418)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.569 294.025C153.569 294.025 148.322 296.577 147.357 299.509C146.583 301.861 140.781 302.165 140.208 306.791C139.912 309.18 138.144 311.093 135.765 311.458C129.839 312.366 120.707 315.443 119.246 325.732C118.131 333.584 122.134 336.562 126.336 337.593C129.421 338.35 131.472 341.351 130.848 344.467C130.249 347.455 131.142 350.909 136.319 353.641C147.92 359.762 159.505 339.139 159.505 339.139L161.879 303.13L153.569 294.025Z",
    fill: "url(#paint7_linear_4_418)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.692 285.488C216.692 285.488 193.53 322.124 165.987 329.201C165.987 329.201 171.354 344.486 175.496 346.236C175.496 346.236 209.382 317.962 218.09 290.694L216.692 285.488Z",
    fill: "url(#paint8_linear_4_418)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.653 525.684L102.653 525.684C102.652 525.694 102.649 525.701 102.647 525.706C102.644 525.712 102.64 525.717 102.636 525.722C102.631 525.726 102.627 525.729 102.625 525.73C102.623 525.731 102.621 525.732 102.615 525.732L102.615 525.732C100.806 525.939 98.0273 526.14 95.3094 525.899C95.9594 523.929 96.9256 521.574 98.1149 519.951H103.351L102.653 525.684ZM95.1888 526.272L95.1888 526.272L95.1888 526.272Z",
    fill: "url(#paint9_linear_4_418)",
    stroke: "#FF9085",
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.505 447.522L160.66 454.319C160.66 454.319 156.791 493.513 156.102 509.191C155.995 511.649 156.63 514.078 157.92 516.173L164.649 527.099L147.549 517.009L147.208 514.922L150.008 511.073L146.341 467.165C146.126 464.586 146.658 461.999 147.874 459.714L151.411 453.07L159.505 447.522Z",
    fill: "url(#paint10_linear_4_418)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.531 526.182L163.826 525.762L163.531 526.182H163.531ZM148.371 517.477C148.625 517.859 148.916 518.242 149.251 518.611C148.988 518.74 148.749 518.9 148.537 519.076L148.407 518.263L148.407 518.263C148.364 517.999 148.353 517.736 148.371 517.477Z",
    fill: "url(#paint11_linear_4_418)",
    stroke: "#FF9085",
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.083 450.75C136.083 450.75 113.415 493.75 109.811 503.568C106.208 513.385 104.946 521.575 104.897 522.351C104.822 523.563 103.314 524.725 99.1594 524.725C97.0151 524.725 95.965 523.866 95.4508 523.034C95.0122 522.324 94.9895 521.436 95.3591 520.688C96.6704 518.034 100.832 509.554 102.373 505.707C104.213 501.115 108.171 480.302 110.341 473.066C112.512 465.83 114.966 457.981 124.419 450.75C124.419 450.75 130.908 444.395 136.083 450.75Z",
    fill: "url(#paint12_linear_4_418)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.404 380.292C156.251 355.514 141.438 341.5 141.438 341.5C150.785 332.528 167.815 328.446 167.815 328.446C167.815 328.446 184.065 340.326 182.137 349.625C181.008 355.075 170.715 382.271 170.715 382.271C170.715 382.271 161.197 386.775 150.404 380.292Z",
    fill: "url(#paint13_linear_4_418)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.439 392.559C139.818 385.39 150.404 380.292 150.404 380.292C161.197 386.775 170.715 382.271 170.715 382.271C170.715 382.271 172.849 390.429 171.376 398.011C169.903 405.593 160.66 454.319 160.66 454.319C146.097 457.27 123.699 451.35 123.699 451.35C132.975 434.881 135.059 399.728 137.439 392.559Z",
    fill: "url(#paint14_linear_4_418)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.191 312.071L152.437 333.426C151.982 335.307 153.697 334.999 155.598 334.64C158.712 334.053 162.726 332.844 164.068 330.421C164.205 330.174 164.273 329.895 164.311 329.616L166.354 314.808C166.516 313.633 165.881 312.493 164.797 312.013L160.855 310.265C159.338 309.592 157.581 310.458 157.191 312.071Z",
    fill: "url(#paint15_linear_4_418)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.297 292.605C166.297 292.605 171.358 296.031 173.533 304.756C175.708 313.481 172.173 316.61 168.551 316.418C164.928 316.227 159.675 315.106 155.124 308.847C150.572 302.588 159.665 288.418 166.297 292.605Z",
    fill: "url(#paint16_linear_4_418)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.713 305.328C159.713 305.328 157.859 292.826 168.239 294.738L170.337 296.923C170.337 296.923 175.418 291.202 169.796 286.877C164.173 282.551 156.371 283.659 152.054 291.533C147.738 299.407 146.171 304.94 149.789 309.833C153.407 314.725 156.129 310.529 156.129 310.529C156.129 310.529 154.47 306.294 155.846 304.477C157.223 302.66 158.999 305.534 158.999 305.534L159.713 305.328Z",
    fill: "url(#paint17_linear_4_418)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.295 306.398C158.295 306.398 157.379 299.966 154.094 301.805C150.809 303.644 155.278 307.814 157.07 309.232L158.295 306.398Z",
    fill: "url(#paint18_linear_4_418)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.533 293.03C216.603 293.786 213.793 294.308 212.898 291.086C213.144 289.688 213.581 283.562 214.653 282.611C220.365 277.542 230.551 271.841 230.551 271.841C231.69 273.58 230.196 274.726 230.196 274.726L225.111 278.157C225.642 279.914 226.416 281.467 226.504 283.473C226.57 284.991 226.009 286.478 225.001 287.63C223.989 288.787 222.627 290.279 221.398 291.413C219.075 293.558 216.533 293.03 216.533 293.03Z",
    fill: "url(#paint19_linear_4_418)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.292 290.531L218.521 290.215C218.625 289.963 221.064 284.035 222.244 282.802C222.693 282.333 222.91 281.932 222.89 281.607C222.879 281.431 222.792 281.257 222.626 281.079L218.508 283.281L216.691 286.127L215.989 285.679L217.923 282.649L222.739 280.074L222.954 280.25C223.441 280.647 223.692 281.074 223.722 281.556C223.757 282.129 223.471 282.725 222.847 283.378C221.957 284.308 219.979 288.857 219.292 290.531Z",
    fill: "url(#paint20_linear_4_418)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M141.438 341.5C141.438 341.5 115.119 395.538 105.587 400.262C105.587 400.262 95.9102 401.273 89.9876 403.064C88.4977 403.515 88.5477 405.63 90.0492 406.04C94.1736 407.165 101.007 408.105 107.269 404.705C107.269 404.705 103.905 409.748 105.868 411.712C105.868 411.712 110.353 406.387 112.035 404.705C113.516 403.224 140.468 373.841 151.799 356.12C152.715 354.688 152.079 350.433 151.443 348.857C149.98 345.23 146.732 339.44 141.438 341.5Z",
    fill: "url(#paint21_linear_4_418)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M302.768 309.974C346.368 309.974 381.712 274.63 381.712 231.03C381.712 187.431 346.368 152.086 302.768 152.086C259.169 152.086 223.824 187.431 223.824 231.03C223.824 274.63 259.169 309.974 302.768 309.974Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M328.374 202.609C328.374 216.078 317.456 230.619 303.987 230.619C290.518 230.619 279.599 216.078 279.599 202.609C279.599 189.141 290.518 179.585 303.987 179.585C317.456 179.585 328.374 189.14 328.374 202.609Z",
    fill: "url(#paint22_linear_4_418)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M273.721 282.475H333.256C339.523 282.475 345.071 278.425 346.981 272.456L350.184 262.443C352.53 255.112 348.716 247.175 341.487 244.531C317.259 235.673 292.206 236.809 266.542 245.349C259.352 247.741 255.363 255.431 257.346 262.744L259.813 271.838C261.517 278.117 267.216 282.475 273.721 282.475Z",
    fill: "url(#paint23_linear_4_418)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M228.686 409.965C228.573 413.471 225.648 416.284 222.149 416.247C218.645 416.21 215.893 413.331 216.006 409.817C216.119 406.303 219.054 403.491 222.557 403.535C226.056 403.58 228.798 406.458 228.686 409.965Z",
    fill: "url(#paint24_linear_4_418)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M252.405 410.241C252.293 413.733 249.391 416.534 245.92 416.498C242.445 416.461 239.716 413.594 239.828 410.094C239.941 406.594 242.852 403.793 246.327 403.837C249.797 403.882 252.517 406.748 252.405 410.241Z",
    fill: "url(#paint25_linear_4_418)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M277.834 410.66C277.722 414.167 274.797 416.979 271.297 416.942C267.794 416.905 265.042 414.027 265.155 410.513C265.268 406.999 268.202 404.186 271.706 404.231C275.205 404.275 277.947 407.154 277.834 410.66Z",
    fill: "url(#paint26_linear_4_418)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M328.13 411.258C328.018 414.75 325.116 417.551 321.645 417.515C318.17 417.478 315.44 414.611 315.553 411.112C315.665 407.612 318.576 404.811 322.051 404.855C325.522 404.899 328.242 407.766 328.13 411.258Z",
    fill: "url(#paint27_linear_4_418)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M353.56 411.677C353.447 415.184 350.522 417.996 347.023 417.96C343.519 417.923 340.767 415.044 340.88 411.53C340.993 408.016 343.928 405.203 347.431 405.248C350.93 405.292 353.672 408.171 353.56 411.677Z",
    fill: "url(#paint28_linear_4_418)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M301.554 410.936C301.442 414.428 298.54 417.23 295.069 417.193C291.594 417.156 288.865 414.29 288.977 410.79C289.089 407.29 292.001 404.489 295.476 404.533C298.946 404.577 301.666 407.444 301.554 410.936Z",
    fill: "url(#paint29_linear_4_418)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8346 234.602C79.5976 234.611 79.366 234.487 79.2527 234.267C78.8785 233.539 78.5136 232.792 78.1681 232.045C78.0261 231.738 78.1656 231.377 78.4797 231.238C79.2394 230.896 79.3558 231.749 80.3679 233.717C80.5227 234.018 80.3983 234.385 80.0902 234.537C80.008 234.577 79.9211 234.598 79.8346 234.602Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3979 224.866C74.9284 223.366 74.5143 221.829 74.1668 220.297C74.0924 219.968 74.3045 219.642 74.6412 219.569C75.5596 219.374 75.2087 220.087 76.5915 224.507C76.6923 224.829 76.5068 225.17 76.1772 225.269C75.8429 225.369 75.4974 225.184 75.3979 224.866ZM72.9498 212.716C72.7999 211.145 72.7098 209.538 72.6861 207.997C72.6723 207.168 73.9219 207.182 73.9338 207.976C73.9587 209.512 74.0457 211.062 74.1926 212.6C74.2247 212.935 73.9724 213.233 73.6292 213.265C73.2821 213.297 72.9817 213.048 72.9498 212.716ZM73.0594 200.33C73.2374 198.771 73.4813 197.199 73.784 195.657C73.9408 194.862 75.1653 195.094 75.0097 195.885C74.7129 197.396 74.4741 198.937 74.2997 200.463C74.2079 201.267 72.9677 201.131 73.0594 200.33ZM76.1552 188.989C75.8277 188.884 75.6495 188.54 75.7575 188.22C76.2586 186.728 76.8274 185.237 77.4474 183.787C77.7664 183.041 78.9174 183.51 78.599 184.255C77.9916 185.676 77.4342 187.138 76.9428 188.599C76.8354 188.919 76.4821 189.094 76.1552 188.989ZM81.1606 177.732C80.862 177.565 80.7595 177.192 80.9316 176.9C81.7337 175.538 82.6002 174.191 83.5071 172.895C83.9749 172.23 85.0033 172.916 84.5369 173.583C83.6482 174.852 82.7988 176.172 82.0131 177.507C81.8411 177.799 81.4592 177.9 81.1606 177.732ZM88.8344 167.854C88.6789 167.86 88.5213 167.81 88.3959 167.701C88.1384 167.478 88.1149 167.092 88.344 166.84C89.4118 165.664 90.5385 164.516 91.6934 163.428C91.9419 163.193 92.3364 163.2 92.5759 163.442C92.8147 163.685 92.8073 164.071 92.5592 164.305C91.4274 165.372 90.3232 166.497 89.2766 167.65C89.1591 167.779 88.9982 167.848 88.8344 167.854ZM98.078 159.554C97.8791 159.561 97.6803 159.477 97.5527 159.309C97.3469 159.039 97.4044 158.657 97.6808 158.455C98.9678 157.517 100.309 156.616 101.667 155.779C101.958 155.598 102.344 155.683 102.528 155.969C102.711 156.253 102.624 156.63 102.332 156.81C101.001 157.631 99.687 158.513 98.4262 159.433C98.3211 159.509 98.1995 159.549 98.078 159.554ZM108.264 152.911C108.118 152.606 108.255 152.243 108.567 152.101C110.022 151.439 111.523 150.826 113.03 150.276C113.807 149.996 114.236 151.138 113.464 151.419C111.988 151.957 110.517 152.559 109.092 153.207C108.78 153.349 108.409 153.217 108.264 152.911ZM150.16 149.607C145.617 148.439 144.863 148.808 145.033 147.898C145.095 147.566 145.42 147.347 145.759 147.406C147.338 147.684 148.926 148.028 150.479 148.427C151.276 148.632 150.959 149.812 150.16 149.607ZM120.085 148.79C120.007 148.462 120.216 148.134 120.551 148.058C122.113 147.701 123.71 147.399 125.298 147.161C126.115 147.039 126.301 148.245 125.485 148.367C123.929 148.6 122.364 148.896 120.833 149.245C120.494 149.322 120.162 149.115 120.085 148.79ZM137.892 147.746C133.212 147.513 132.537 148.026 132.514 147.098C132.499 146.51 133.19 146.44 133.122 146.472C134.731 146.429 136.358 146.448 137.957 146.528C138.302 146.545 138.566 146.832 138.548 147.168C138.53 147.489 138.256 147.76 137.892 147.746Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M159.759 152.947C157.848 152.099 156.83 151.968 157.15 151.2C157.28 150.888 157.644 150.736 157.964 150.864C159.975 151.662 160.924 151.919 160.586 152.643C160.485 152.861 160.072 153.085 159.759 152.947Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M192.469 187.517C192.203 187.528 191.95 187.37 191.856 187.112C191.583 186.355 191.291 185.595 190.987 184.854C190.86 184.541 191.015 184.186 191.335 184.06C191.655 183.936 192.018 184.086 192.147 184.399C192.456 185.156 192.754 185.931 193.033 186.704C193.148 187.021 192.978 187.37 192.653 187.483C192.592 187.504 192.53 187.515 192.469 187.517Z",
    fill: "url(#paint30_linear_4_418)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M135.205 267.544C133.475 267.565 131.724 267.514 130.001 267.393C129.658 267.369 129.4 267.077 129.425 266.74C129.497 265.794 130.13 266.385 135.192 266.324C135.536 266.32 135.819 266.589 135.822 266.926C135.828 267.515 135.137 267.575 135.205 267.544ZM142.926 266.371C142.785 265.434 143.56 265.867 148.462 264.743C148.798 264.664 149.134 264.87 149.212 265.197C149.29 265.525 149.081 265.853 148.746 265.93C147.068 266.315 145.348 266.636 143.633 266.885C143.29 266.934 142.975 266.702 142.926 266.371ZM121.631 266.235C119.942 265.884 118.246 265.458 116.591 264.968C116.261 264.87 116.075 264.53 116.176 264.207C116.459 263.298 116.942 264.013 121.892 265.042C122.229 265.112 122.444 265.436 122.372 265.766C122.299 266.095 121.968 266.305 121.631 266.235ZM156.628 263.538C156.369 263.548 156.12 263.398 156.022 263.147C155.898 262.833 156.059 262.48 156.381 262.359C157.965 261.763 159.539 261.094 161.06 260.372C161.371 260.225 161.744 260.351 161.894 260.654C162.044 260.957 161.914 261.322 161.604 261.469C160.051 262.206 158.444 262.889 156.828 263.497C156.762 263.522 156.695 263.535 156.628 263.538ZM168.616 257.462C168.406 257.47 168.197 257.374 168.072 257.191C167.881 256.911 167.959 256.532 168.246 256.345C169.653 255.426 171.039 254.436 172.366 253.402C172.636 253.192 173.028 253.235 173.242 253.498C173.457 253.762 173.412 254.145 173.143 254.356C171.789 255.411 170.374 256.421 168.937 257.359C168.838 257.424 168.727 257.457 168.616 257.462ZM178.956 248.964C178.793 248.97 178.628 248.915 178.5 248.796C178.251 248.564 178.242 248.177 178.481 247.934C179.65 246.735 180.783 245.474 181.847 244.183C182.064 243.921 182.456 243.879 182.725 244.09C182.993 244.301 183.035 244.685 182.818 244.948C181.732 246.264 180.577 247.552 179.383 248.775C179.266 248.894 179.112 248.958 178.956 248.964ZM187.159 238.468C187.041 238.473 186.921 238.445 186.813 238.381C186.518 238.207 186.423 237.832 186.601 237.544C187.477 236.126 188.302 234.653 189.054 233.168C189.207 232.866 189.58 232.741 189.89 232.891C190.199 233.039 190.325 233.405 190.172 233.707C189.406 235.223 188.564 236.726 187.67 238.173C187.557 238.356 187.362 238.46 187.159 238.468ZM192.607 226.447C191.687 226.148 192.43 225.696 193.624 220.882C193.818 220.097 195.032 220.382 194.837 221.167C194.429 222.81 193.945 224.456 193.397 226.06C193.288 226.378 192.935 226.554 192.607 226.447ZM195.578 213.561C194.613 213.468 195.234 212.874 195.315 207.918C195.329 207.115 196.577 207.127 196.563 207.935C196.535 209.627 196.434 211.335 196.261 213.014C196.226 213.354 195.912 213.596 195.578 213.561ZM195.529 200.368C195.207 200.381 194.925 200.15 194.886 199.832C194.684 198.181 194.409 196.525 194.07 194.911C194.001 194.581 194.219 194.259 194.557 194.19C194.896 194.124 195.224 194.334 195.293 194.664C195.639 196.311 195.919 198 196.125 199.685C196.166 200.019 195.922 200.323 195.58 200.364C195.562 200.366 195.546 200.367 195.529 200.368Z",
    fill: "url(#paint31_linear_4_418)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M108.653 262.019C106.678 261.13 105.746 260.832 106.118 260.123C106.505 259.386 107.155 260 109.178 260.911C109.49 261.052 109.626 261.415 109.482 261.721C109.337 262.027 108.966 262.16 108.653 262.019Z",
    fill: "url(#paint32_linear_4_418)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.891 245.126L116.61 240.67C120.327 242.538 124.377 243.841 128.632 244.467C132.275 252.186 131.983 252.986 132.941 252.91L143.652 252.064C143.964 252.039 144.227 251.823 144.306 251.526L146.548 243.051C150.649 241.764 154.438 239.843 157.807 237.414L166.144 240.602C166.436 240.713 166.769 240.632 166.973 240.398L173.948 232.397C174.152 232.164 174.181 231.829 174.022 231.565L169.477 224.029C171.395 220.393 172.735 216.432 173.383 212.271L181.589 208.761C181.877 208.638 182.054 208.35 182.029 208.045L181.182 197.577C181.157 197.271 180.937 197.014 180.633 196.938L171.967 194.762C170.658 190.756 168.699 187.056 166.22 183.766C169.25 175.736 170.015 175.406 169.289 174.802C161.156 168.27 161.111 167.44 160.266 167.928L152.548 172.384C148.83 170.516 144.78 169.214 140.525 168.587C136.885 160.873 137.175 160.069 136.216 160.144C125.589 161.168 125.092 160.617 124.851 161.528L122.609 170.003C118.508 171.29 114.719 173.211 111.349 175.64C103.239 172.728 102.813 171.935 102.184 172.656C95.4217 180.694 94.644 180.674 95.1349 181.488L99.6802 189.025C97.7618 192.661 96.4224 196.622 95.774 200.783C88.009 204.294 87.0505 204.054 87.1281 205.01C88.1518 215.35 87.5866 215.88 88.5241 216.116L97.1902 218.292C98.4993 222.298 100.458 225.998 102.937 229.288C99.9167 237.291 99.1389 237.644 99.868 238.252C108.001 244.784 108.046 245.614 108.891 245.126Z",
    fill: "url(#paint33_linear_4_418)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M124.655 209.825C122.804 204.48 125.75 198.652 131.222 196.833C136.694 195.016 142.651 197.884 144.503 203.229C146.353 208.574 143.407 214.403 137.935 216.221C132.462 218.041 126.505 215.17 124.655 209.825ZM131.822 198.566C127.38 200.042 124.885 204.78 126.428 209.236C127.948 213.626 132.842 215.984 137.336 214.489C141.829 212.995 144.249 208.208 142.729 203.818C141.207 199.422 136.308 197.074 131.822 198.566Z",
    fill: "url(#paint34_linear_4_418)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M135.732 232.58C134.185 232.641 132.636 232.573 131.113 232.376C130.655 232.317 130.319 231.943 130.302 231.507C130.3 231.455 130.302 231.402 130.309 231.349C130.378 230.848 130.851 230.496 131.362 230.562C133.113 230.788 134.903 230.831 136.682 230.692C150.076 229.633 160.195 218.382 159.683 205.377C159.67 205.044 159.65 204.711 159.624 204.377C158.531 190.871 146.457 180.92 132.743 182C119.048 183.082 108.717 194.843 109.801 208.315C110.45 216.333 114.482 220.191 114.515 221.031C114.551 221.938 113.354 222.337 112.817 221.601C109.883 217.579 108.078 212.666 107.87 207.387C106.975 184.608 134.416 171.582 152.15 186.345C157.607 190.888 160.924 197.239 161.489 204.23C161.519 204.592 161.54 204.953 161.555 205.313C161.815 211.919 159.56 218.288 155.144 223.354C150.486 228.697 143.981 231.95 136.829 232.515C136.464 232.544 136.098 232.566 135.732 232.58Z",
    fill: "url(#paint35_linear_4_418)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M187.128 162.736C189.273 163.633 191.576 164.195 193.963 164.365L196.31 168.753C196.571 169.24 196.894 168.835 202.633 168.017C203.16 167.933 202.894 167.536 203.827 162.782C206.041 161.874 208.054 160.62 209.81 159.096L214.576 160.54C215.105 160.7 215.047 160.185 218.526 155.549C218.629 155.408 218.63 155.217 218.53 155.074L215.667 151C216.565 148.855 217.126 146.551 217.296 144.165C221.442 141.834 221.981 141.928 221.895 141.392C220.855 135.569 221.145 135.249 220.615 135.157L215.713 134.3C214.805 132.086 213.551 130.074 212.027 128.317L213.471 123.552C213.631 123.024 213.116 123.081 208.481 119.602C208.051 119.29 207.973 119.745 203.931 122.461C201.786 121.563 199.482 121.001 197.096 120.832L194.749 116.444C194.488 115.957 194.165 116.362 188.426 117.18C187.902 117.263 188.169 117.637 187.232 122.415C185.018 123.323 183.005 124.577 181.249 126.101L176.484 124.657C176.317 124.606 176.136 124.667 176.033 124.809L172.533 129.648C172.431 129.789 172.429 129.98 172.53 130.123L175.392 134.197C174.495 136.342 173.933 138.646 173.763 141.033C169.617 143.363 169.078 143.269 169.165 143.805C170.204 149.626 169.915 149.948 170.444 150.04L175.346 150.897C176.254 153.11 177.508 155.123 179.032 156.88C177.748 161.459 177.298 161.775 177.74 162.095L182.579 165.596C183.011 165.908 183.107 165.437 187.128 162.736Z",
    fill: "url(#paint36_linear_4_418)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M189.805 145.062C188.444 141.898 189.902 138.236 193.066 136.874C196.229 135.513 199.892 136.971 201.254 140.135C202.612 143.291 201.149 146.964 197.993 148.323C194.836 149.681 191.164 148.219 189.805 145.062ZM191.511 144.327C192.465 146.543 195.044 147.569 197.259 146.617C200.816 145.085 200.76 139.973 197.148 138.534C193.553 137.103 189.97 140.747 191.511 144.327Z",
    fill: "url(#paint37_linear_4_418)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M171.888 165.102C171.311 164.497 170.75 163.86 170.22 163.208C170.004 162.943 170.044 162.553 170.31 162.337C170.977 161.794 171.297 162.686 172.785 164.248C173.021 164.496 173.011 164.888 172.764 165.124C172.517 165.359 172.125 165.351 171.888 165.102Z",
    fill: "#91B3FA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M165.856 156.176C165.172 154.681 164.57 153.068 164.099 151.388C163.877 150.598 165.07 150.267 165.291 151.053C166.514 155.406 167.619 156.051 166.676 156.482C166.362 156.625 165.997 156.485 165.856 156.176ZM163.522 143.806C163.18 143.813 162.898 143.541 162.891 143.199C162.861 141.503 162.964 139.79 163.199 138.106C163.313 137.295 164.539 137.466 164.426 138.278C164.2 139.897 164.1 141.545 164.13 143.176C164.141 143.776 163.455 143.839 163.522 143.806ZM165.967 130.978C165.88 130.982 165.791 130.967 165.706 130.932C165.39 130.801 165.24 130.439 165.37 130.123C166.019 128.554 166.796 127.024 167.679 125.576C167.857 125.284 168.239 125.192 168.53 125.369C168.822 125.547 168.914 125.929 168.736 126.22C167.886 127.614 167.139 129.086 166.515 130.596C166.419 130.827 166.201 130.969 165.967 130.978ZM173.302 120.18C173.132 120.186 172.96 120.123 172.833 119.991C172.595 119.746 172.602 119.353 172.848 119.116C174.068 117.936 175.392 116.844 176.783 115.87C177.063 115.675 177.449 115.742 177.645 116.023C177.841 116.303 177.773 116.689 177.493 116.885C176.155 117.822 174.881 118.872 173.708 120.006C173.594 120.116 173.449 120.174 173.302 120.18ZM183.743 112.817C183.623 112.497 183.785 112.14 184.106 112.02C185.7 111.423 187.349 110.948 189.007 110.608C189.806 110.44 190.061 111.655 189.256 111.821C187.661 112.148 186.075 112.605 184.541 113.18C184.212 113.302 183.861 113.131 183.743 112.817Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M199.642 111.46C197.39 111.16 196.596 111.416 196.641 110.581C196.66 110.24 196.944 109.976 197.293 109.997C198.126 110.042 198.971 110.121 199.806 110.232C200.144 110.277 200.383 110.589 200.338 110.928C200.293 111.261 199.988 111.504 199.642 111.46Z",
    fill: "#91B3FA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M221.469 124.887C220.185 123.003 219.468 122.587 220.121 122.064C220.388 121.85 220.777 121.894 220.991 122.16C221.513 122.811 222.018 123.494 222.492 124.19C222.684 124.472 222.611 124.857 222.329 125.05C222.047 125.242 221.661 125.17 221.469 124.887Z",
    fill: "url(#paint38_linear_4_418)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M199.723 174.348C199.568 173.332 200.677 173.895 204.943 172.549C205.721 172.302 206.098 173.483 205.315 173.73C203.72 174.233 202.076 174.616 200.429 174.867C200.096 174.918 199.775 174.691 199.723 174.348ZM211.862 170.142C211.683 169.851 211.773 169.47 212.064 169.29C215.902 166.921 216.162 165.73 216.834 166.513C217.056 166.773 217.026 167.164 216.766 167.387C215.499 168.471 214.136 169.466 212.714 170.344C212.423 170.523 212.042 170.433 211.862 170.142ZM221.373 161.513C220.529 160.921 221.697 160.521 223.682 156.499C224.045 155.766 225.155 156.312 224.793 157.047C224.053 158.546 223.193 159.998 222.235 161.362C222.039 161.642 221.653 161.71 221.373 161.513ZM226.726 149.837C225.716 149.621 226.639 148.795 226.889 144.319C226.934 143.502 228.171 143.569 228.125 144.387C228.032 146.053 227.809 147.725 227.461 149.36C227.39 149.695 227.06 149.907 226.726 149.837ZM226.341 136.508C225.464 132.087 224.437 131.421 225.409 131.067C225.731 130.949 226.086 131.115 226.203 131.436C226.777 133.009 227.232 134.635 227.555 136.267C227.622 136.603 227.404 136.929 227.068 136.995C226.734 137.061 226.408 136.844 226.341 136.508Z",
    fill: "url(#paint39_linear_4_418)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M192.261 175.07C191.426 174.985 190.586 174.867 189.762 174.718C189.426 174.658 189.202 174.336 189.263 173.999C189.416 173.152 190.235 173.62 192.386 173.838C192.726 173.873 192.974 174.177 192.939 174.517C192.904 174.862 192.595 175.105 192.261 175.07Z",
    fill: "url(#paint40_linear_4_418)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M194.802 157.812C194.215 157.784 193.861 157.317 193.887 156.833C193.914 156.321 194.356 155.927 194.864 155.955C195.815 156.006 196.78 155.955 197.732 155.802C197.921 155.733 202.982 155.269 206.519 150.393C213.527 140.705 205.277 127.279 193.459 129.177C186.66 130.269 181.857 136.295 182.122 143.011C182.388 149.776 186.693 151.173 185.153 152.467C184.76 152.797 184.175 152.747 183.844 152.354C182.063 150.236 180.889 147.666 180.449 144.92C179.109 136.584 184.801 128.686 193.165 127.343C202.165 125.898 210.561 132.628 210.927 141.918C211.222 149.41 205.911 156.371 198.026 157.636H198.025C196.958 157.807 195.873 157.867 194.802 157.812Z",
    fill: "url(#paint41_linear_4_418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4_418",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303 303) rotate(90) scale(303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6E57",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_418",
    x1: 175.047,
    y1: 0.00000187602,
    x2: 360.757,
    y2: 597.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4_418",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303 302) rotate(90) scale(264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_418",
    x1: 303,
    y1: 38,
    x2: 356.333,
    y2: 536.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_418",
    x1: 626.588,
    y1: 675.811,
    x2: 181.519,
    y2: 123.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_418",
    x1: 157.057,
    y1: 315.031,
    x2: 448.479,
    y2: 315.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_418",
    x1: 266.755,
    y1: 84.9509,
    x2: 265.122,
    y2: 243.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_418",
    x1: 98.1662,
    y1: 368.212,
    x2: 158.259,
    y2: 314.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_418",
    x1: 171.92,
    y1: 339.652,
    x2: 231.418,
    y2: 262.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_418",
    x1: 105.901,
    y1: 522.98,
    x2: 92.7032,
    y2: 522.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1473D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_418",
    x1: 161.67,
    y1: 575.026,
    x2: 142.677,
    y2: 353.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_418",
    x1: 167.218,
    y1: 520.57,
    x2: 145.863,
    y2: 520.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1473D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_418",
    x1: 123.464,
    y1: 578.328,
    x2: 104.466,
    y2: 356.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_418",
    x1: 96.7152,
    y1: 496.652,
    x2: 157.126,
    y2: 359.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA80F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_418",
    x1: 108.887,
    y1: 355.498,
    x2: 156.372,
    y2: 431.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4_418",
    x1: 163.404,
    y1: 284.855,
    x2: 157.236,
    y2: 345.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4_418",
    x1: 170.105,
    y1: 324.787,
    x2: 150.334,
    y2: 264.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4_418",
    x1: 89.2401,
    y1: 358.183,
    x2: 149.333,
    y2: 304.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4_418",
    x1: 162.882,
    y1: 327.152,
    x2: 143.111,
    y2: 266.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4_418",
    x1: 175.636,
    y1: 342.513,
    x2: 235.134,
    y2: 265.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4_418",
    x1: 220.744,
    y1: 277.745,
    x2: 226.186,
    y2: 241.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4_418",
    x1: 88.8963,
    y1: 376.39,
    x2: 152.257,
    y2: 376.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4_418",
    x1: 432.8,
    y1: -8.82438,
    x2: 99.8216,
    y2: 539.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4_418",
    x1: 458.219,
    y1: 6.60843,
    x2: 125.241,
    y2: 555.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4_418",
    x1: 253.38,
    y1: 182.588,
    x2: 230.955,
    y2: 346.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4_418",
    x1: 276.753,
    y1: 185.779,
    x2: 254.328,
    y2: 350.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4_418",
    x1: 301.723,
    y1: 189.189,
    x2: 279.298,
    y2: 353.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4_418",
    x1: 351.228,
    y1: 195.948,
    x2: 328.803,
    y2: 360.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4_418",
    x1: 376.199,
    y1: 199.357,
    x2: 353.774,
    y2: 363.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4_418",
    x1: 325.096,
    y1: 192.379,
    x2: 302.67,
    y2: 356.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4_418",
    x1: 190.943,
    y1: 185.767,
    x2: 193.069,
    y2: 185.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4_418",
    x1: 116.148,
    y1: 230.864,
    x2: 196.563,
    y2: 230.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4_418",
    x1: 106.038,
    y1: 260.936,
    x2: 109.539,
    y2: 260.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4_418",
    x1: 87.124,
    y1: 206.527,
    x2: 182.031,
    y2: 206.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4_418",
    x1: 124.102,
    y1: 206.528,
    x2: 145.056,
    y2: 206.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4_418",
    x1: 107.848,
    y1: 206.336,
    x2: 161.575,
    y2: 206.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4_418",
    x1: 169.156,
    y1: 142.598,
    x2: 221.903,
    y2: 142.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4_418",
    x1: 189.295,
    y1: 142.597,
    x2: 201.761,
    y2: 142.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4_418",
    x1: 219.875,
    y1: 123.543,
    x2: 222.599,
    y2: 123.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4_418",
    x1: 199.709,
    y1: 152.952,
    x2: 228.127,
    y2: 152.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4_418",
    x1: 189.253,
    y1: 174.292,
    x2: 192.942,
    y2: 174.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4_418",
    x1: 180.254,
    y1: 142.49,
    x2: 210.938,
    y2: 142.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/signUp.f462b8317e4f33a9f6c7b8e892658140.svg";
export { ForwardRef as ReactComponent };